import type { DraftReviewInfo } from './utils';

interface DraftStatusBadgeProps {
    reviewInfo: DraftReviewInfo;
}

/**
 * Visual pill that summarises a Dx draft's review state. Order of
 * precedence: in_review > approved > (changes-requested history) > plain
 * draft.
 */
export function DraftStatusBadge({ reviewInfo }: DraftStatusBadgeProps) {
    if (reviewInfo.state === 'in_review') {
        return (
            <span className="inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded border bg-amber-50 text-amber-700 border-amber-300 flex-shrink-0">
                In review
            </span>
        );
    }
    if (reviewInfo.state === 'approved') {
        return (
            <span className="inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded border bg-green-50 text-green-700 border-green-300 flex-shrink-0">
                Approved
            </span>
        );
    }
    if (reviewInfo.hasRequestChangesHistory) {
        return (
            <span className="inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded border bg-red-50 text-red-700 border-red-300 flex-shrink-0">
                Changes requested
            </span>
        );
    }
    return (
        <span className="inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded border bg-gray-100 text-gray-700 border-gray-300 flex-shrink-0">
            Draft
        </span>
    );
}
